export default __webpack_public_path__ + "static/media/O-016.ae5dbaad.png";